import enLocale from 'date-fns/locale/en-US';
import svLocale from 'date-fns/locale/sv';
import { FormattedMessage } from 'react-intl';
import React from 'react';

export const localeMap = {
  en: enLocale,
  sv: svLocale,
};

export const cancelLabel = <FormattedMessage
  id="date.picker.cancel"
  defaultMessage="Cancel"
/>;

export const clearLabel = <FormattedMessage
  id="date.picker.clear"
  defaultMessage="Clear"
/>;